import styled, { css } from 'styled-components';

export const WrapperFullScreen = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  position: absolute;

  > header {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

const wrapperModifiers = {
  full: () => css`
    padding: 2rem;
  `,
};

export const Wrapper = styled.div`
  ${({ fullScreen }) => css`
    background-color: #fff;

    width: 100%;
    height: 100%;

    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-auto-flow: column;

    justify-items: center;

    overflow-x: auto;

    gap: 2rem;

    ${fullScreen && wrapperModifiers.full()}

    @media (min-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }

    @media (min-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 1rem;
    }

    @media (min-width: 1440px) {
      grid-template-columns: repeat(4, 1fr);
      gap: 0.7rem;
    }
  `}
`;
